import { render, staticRenderFns } from "./ConnyPet.vue?vue&type=template&id=0a0929a1&scoped=true&"
import script from "./ConnyPet.vue?vue&type=script&lang=js&"
export * from "./ConnyPet.vue?vue&type=script&lang=js&"
import style0 from "./ConnyPet.vue?vue&type=style&index=0&id=0a0929a1&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a0929a1",
  null
  
)

export default component.exports